import { render, staticRenderFns } from "./YouTube.vue?vue&type=template&id=320788d8&scoped=true"
import script from "./YouTube.vue?vue&type=script&lang=ts"
export * from "./YouTube.vue?vue&type=script&lang=ts"
import style0 from "./YouTube.vue?vue&type=style&index=0&id=320788d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320788d8",
  null
  
)

export default component.exports